/** Used only until the review has loaded: the engine reports its real (configurable)
 *  cap as `max_notes_chars`, and the counter follows that. */
export const DEFAULT_MAX_NOTES_CHARS = 500;

/** "mira_cho" → "Mira Cho": the planner's character key, readable. */
export function characterLabel(charKey: string): string {
  return charKey.replace(/[_-]+/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
}
